import { registerUser } from 'helpers/api';
import { formatFormData } from 'helpers/utils';

const state = {
    isFetching: false,
    fields: {
        CompanyName: false,
        AccountNumber: false,
        FirstName: false,
        LastName: false,
        PhoneNumber: false,
        Email: false,
        Address: false,
        City: false,
        State: false,
        Zip: false,
    },
};

// ==================================================
// HANDLERS
// ==================================================

function handleFieldChange(e) {
    const field = e.target;
    const { id } = field;

    if (state.fields[id]) {
        field.classList.remove('login--error');
        state.fields[id] = false;
    }
}

async function handleSubmit(e) {
    e.preventDefault();
    const form = document.getElementsByClassName(' js--form')[0];
    const filter = filterFields(createFormData(form));

    if (filter.length) {
        return displayErrors();
    }

    state.isFetching = true;
    const res = await registerUser(formatFormData(form));
    state.isFetching = false;

    if (res !== 200) {
        return document.getElementsByClassName('js--register-error')[0].classList.remove('none');
    }

    Array.from(document.querySelectorAll('.js--register-info, .js--form')).forEach((k) =>
        k.classList.add('none'),
    );
    document.getElementsByClassName('js--register-success')[0].classList.remove('none');
}

// ==================================================
// HELPERS
// ==================================================

function displayErrors() {
    document.getElementsByClassName('login__err-occured')[0].classList.add('show-message');
    const { fields } = state;

    Object.keys(fields).forEach((k) =>
        fields[k] ? document.getElementById(k).classList.add('login--error') : false,
    );
}

const filterFields = (data) =>
    Array.from(data).filter((k) => {
        const { length } = k[1];

        state.fields[k[0]] = !length;
        return !length;
    });

function createFormData(form) {
    const data = new FormData(form);

    if (data.get('State') === null) {
        data.append('State', '');
    }

    return data;
}

// ==================================================
// INIT
// ==================================================

function init() {
    document
        .getElementsByClassName('js--register-submit')[0]
        .addEventListener('click', (e) => handleSubmit(e));

    Array.from(document.getElementsByClassName('js--login-input')).forEach((k) =>
        k.addEventListener('keyup', (e) => handleFieldChange(e)),
    );
    document.getElementById('State').addEventListener('change', (e) => handleFieldChange(e));

    document
        .getElementsByClassName('js--form')[0]
        .addEventListener('submit', (e) => handleSubmit(e));
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/register-user.js